import React from 'react';

export default function Placeholder() {
    return (
        <div className="si-list-item si-flexBox si-lazy-loading-effect">
            <div className="si-loader-bg si-thumbnail-loader" />
            <div className="si-loader-bg si-header-loader" />
            <div className="si-loader-bg si-sub-header-loader" />
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/onboarding/Placeholder.js